import { Text, Image } from '@vinted/web-ui';
import classNames from 'classnames';
import { useMemo } from 'react';
import { AdPlatform, AdShape } from 'constants/ads';
import { CDN_IMAGES_URL } from 'constants/index';
import useTranslate from 'hooks/useTranslate';
import useIsDarkMode from 'hooks/useIsDarkMode';
import AdManager from 'libs/common/ad-manager';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const placeholderVariations = [{
  shape: AdShape.Leaderboard,
  placeholders: {
    desktop: ['/ads/placeholders/leaderboard/desktop-1', '/ads/placeholders/leaderboard/desktop-2', '/ads/placeholders/leaderboard/desktop-3'],
    mobile: ['/ads/placeholders/leaderboard/mobile-1', '/ads/placeholders/leaderboard/mobile-2', '/ads/placeholders/leaderboard/mobile-3']
  }
}];

const getAdPlaceholderImageSrc = (shape, isDarkMode, isMobile) => {
  var _placeholderVariation;

  const placeholders = (_placeholderVariation = placeholderVariations.find(_ref => {
    let {
      shape: variationShape
    } = _ref;
    return variationShape === shape;
  })) === null || _placeholderVariation === void 0 ? void 0 : _placeholderVariation.placeholders;
  if (!placeholders) return null;
  const darkModeSuffix = isDarkMode ? '-dark' : '';
  const platformPlaceholders = isMobile ? placeholders.mobile : placeholders.desktop;
  const randomIndex = Math.floor(Math.random() * platformPlaceholders.length);
  return "".concat(CDN_IMAGES_URL).concat(platformPlaceholders[randomIndex]).concat(darkModeSuffix, ".png");
};

const AdPlaceholder = _ref2 => {
  let {
    shape
  } = _ref2;
  const translate = useTranslate('advertisements');
  const isDarkMode = useIsDarkMode();
  const isMobile = AdManager.getAdsPlatform() === AdPlatform.Mobile;
  const adPlaceholderImageSrc = useMemo(() => getAdPlaceholderImageSrc(shape, isDarkMode, isMobile), [shape, isDarkMode, isMobile]);
  if (!adPlaceholderImageSrc) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('ad-placeholder', "ad-placeholder--".concat(shape)),
    "data-testid": "ad-placeholder",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx(Image, {
      testId: "ad-placeholder-image",
      src: adPlaceholderImageSrc
    }), !isMobile && /*#__PURE__*/_jsx("div", {
      className: "ad-placeholder__text",
      children: /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Subtitle,
        theme: "primary",
        bold: true,
        text: translate('placeholder')
      })
    })]
  });
};

export default AdPlaceholder;